export const flightRegion: any = {
  flightCountryList: "List of destination countries for flights",
  flightRegionList: "Flight area in {{country}}",
};
